module.exports = __webpack_public_path__ + "img/appointmentType.607a1106.png";